<template>
  <div class="palette">
    <div
      v-for="(color, index) in startGameConfig.colors"
      :key="color.val + '_color_' + index"
      :id="'color_' + index"
      @click.self="
        changeColor(color);
        indexOfColor = index;
      "
      :style="color.cssStyle"
      class="color"
    >
      <mb-audio-in-game
        :key="color.audioId + 'audio' + index2"
        v-for="(data, index2) in audioData(color.audioId)"
        :item-data="data"
        :id="data.id"
        :mask-data="maskData"
        @change-item-mask="changeItemMask"
        :style="{
          top: data.pos.y + 'px',
          left: data.pos.x + 'px',
        }"
      ></mb-audio-in-game>
      <img
        v-if="displayImage"
        draggable="false"
        @click="
          changeColor(color);
          indexOfColor = index;
        "
        :src="getImageSrc(index == indexOfColor ? clicked(color) : waitingToBeClicked(color))"
      />
    </div>
  </div>
</template>

<script>
import mbAudioInGame from '__mainSrcDir/components/MbAudioModal/MbAudioInGame';
export default {
  name: 'palette',
  components: { mbAudioInGame },
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      maskData: [],
      indexOfColor: null,
      displayImage: true,
    };
  },
  methods: {
    getImageSrc(imageSrc) {
      if (!imageSrc) {
        this.displayImage = false;
        return null;
      }
      return require(`__staticDir/${this.$store.getters.multibookType}/${imageSrc}`);
    },
    changeColor(color) {
      if (this.startGameConfig.mbPaletteAudioItemData) {
        const maskStatus = this.maskData.filter((el) => el.id === color.audioId)[0]?.isWrapped;
        if (!maskStatus) this.$emit('change-color', color.val);
      } else this.$emit('change-color', color.val);
    },
    clicked(c) {
      let src = '';
      if (c.clicked && c.clicked.src) src = c.clicked.src;
      return src;
    },
    waitingToBeClicked(c) {
      let src = '';
      if (c.waitingToBeClicked && c.waitingToBeClicked.src) src = c.waitingToBeClicked.src;
      return src;
    },
    audioData(id) {
      if (!this.startGameConfig.mbPaletteAudioItemData) return null;
      return this.startGameConfig.mbPaletteAudioItemData.filter((el) => el.id === id);
    },
    changeItemMask(value) {
      if (this.maskData.length > 0) {
        this.maskData = value.item;
      }
    },
    init() {
      if (this.startGameConfig.mbPaletteAudioItemData) {
        this.maskData = this.startGameConfig.mbPaletteAudioItemData
          .filter((d) => d.hasOwnProperty('maskConfig'))
          .map(({ id }) => ({ id: id, isWrapped: true }));
      }
    },
  },
  watch: {
    startGameConfig(newStatus) {
      if (newStatus) {
        this.init();
        this.indexOfColor = null;
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="sass" scoped>
.palette
  position: absolute
  width: 100%
  height: 100%
  pointer-events: none
  .color
    pointer-events: auto
    img
      position: absolute
      left: 0
      top: 0
      width: 100%
      height: 100%
</style>
